export const NotificationsColors = Object.freeze({
    SUCCESS: '#28a745', //green
    ONGOING: '#7dd3fc', //lightblue
    FAIL: '#f87171', //red-400
    WARNING: '#ffd700', //yellow
    CANCELLING: '#94a3b8', //grey-shade
    CANCELLED: '#94a3b8', //grey
});
